document.addEventListener('DOMContentLoaded', function() {
    const sendButton = document.getElementById('chatbox-send');
    const chatboxMessages = document.getElementById('chatbox-messages');
    const input = document.getElementById('chatbox-input');
    const chatboxContainer = document.getElementById('chatbox-container');
    const openButton = document.getElementById('open-chatbot');
    const closeButton = document.getElementById('close-chatbot');
    const botAvatarUrl = 'https://cdn.shopify.com/s/files/1/0679/6725/4816/files/Haamu.png?v=1718803681';
    // const displayChatBox = settings.my_checkbox;

    function sendMessage() {
        const message = input.value.trim();

        if (message === '') {
            sendButton.disabled = true;
            typeWriterEffect(chatboxMessages, 'Haamu: Kirjoitathan viestikenttään asiasi ennen viestin lähettämistä?', sendButton, botAvatarUrl);
        } else {
            input.value = '';
            sendButton.disabled = true;

            fetch('https://c8e1-80-220-82-5.ngrok-free.app/api/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ message: message })
            })
            .then(response => response.json())
            .then(data => {
                chatboxMessages.innerHTML += `<div class="message-container"><div>Sinä: ${message}</div></div>`;
                typeWriterEffect(chatboxMessages, `Haamu: ${data.message}`, sendButton, botAvatarUrl);
            })
            .catch(error => {
                sendButton.disabled = true;
                typeWriterEffect(chatboxMessages, 'Haamu: Tapahtui virhe. Korjaamme asian mahdollisimman pian. Voit sillä aikaa nauttia verkkokauppamme valikoimasta tai olla meihin yhteydessä yhteystieto-osion kautta.', sendButton, botAvatarUrl);
                console.error('Error:', error);
                sendButton.disabled = false;
            });
        }
    }

    sendButton.addEventListener('click', sendMessage);

    function typeWriterEffect(container, message, sendButton, avatarUrl) {
        let i = 0;
        const interval = 50; // Interval in milliseconds between each character
        const messageContainer = document.createElement('div');
        messageContainer.className = 'message-container';
        
        if (avatarUrl) {
            const avatar = document.createElement('img');
            avatar.src = avatarUrl;
            avatar.className = 'bot-avatar';
            messageContainer.appendChild(avatar);
        }
        
        const messageDiv = document.createElement('div');
        messageContainer.appendChild(messageDiv);
        container.appendChild(messageContainer);

        function type() {
            if (i < message.length) {
                messageDiv.innerHTML += message.charAt(i);
                i++;
                setTimeout(type, interval);
            } else {
                sendButton.disabled = false;
            }
            container.scrollTop = container.scrollHeight;
        }

        type();
    }

    function displayGreeting() {
        const firstTime = localStorage.getItem('chatbotFirstTime');
        if (!firstTime) {
            localStorage.setItem('chatbotFirstTime', 'true');
            typeWriterEffect(chatboxMessages, 'Haamu: Hei, olen Haamu, GTSeedsin virtuaalinen avustaja, kuinka voin auttaa tänään?', sendButton, botAvatarUrl);
        }
    }

    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const isVisible = chatboxContainer.style.display !== 'none';
                if (isVisible) {
                    displayGreeting();
                }
            }
        }
    });

    observer.observe(chatboxContainer, { attributes: true });

    const isVisibleOnLoad = chatboxContainer.style.display !== 'none';
    if (isVisibleOnLoad) {
        displayGreeting();
    }

    openButton.addEventListener('click', function() {
        chatboxContainer.style.display = 'block';
        openButton.style.display = 'none';
        displayGreeting(); 
    });

    closeButton.addEventListener('click', function() {
        chatboxContainer.style.display = 'none';
        openButton.style.display = 'block';
    });
});
